import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  HomeOutlined, BookOutlined, TrophyOutlined, ExperimentOutlined,
  ReadOutlined, DownloadOutlined, DollarOutlined, FormOutlined,
  PhoneOutlined, CloseOutlined, ThunderboltOutlined
} from "@ant-design/icons";

export default function Sidebar({ mobileOpen, onClose }) {
  const location = useLocation();

  const menu = [
    { label: "Trang Chủ", to: "/", icon: <HomeOutlined /> },
    { label: "Khóa Học", to: "/topic", icon: <BookOutlined /> },
    { label: "Thi Đấu", to: "/competition", icon: <ThunderboltOutlined />, badge: "New" },
    { label: "Phương Pháp", to: "/method", icon: <ExperimentOutlined /> },
    { label: "Cách Học Chi Tiết", to: "/how", icon: <ReadOutlined /> },
    { label: "Hướng Dẫn Tải App", to: "/download", icon: <DownloadOutlined /> },
    { label: "Bảng Giá", to: "/pricing", icon: <DollarOutlined /> },
    { label: "Blog", to: "/blog", icon: <FormOutlined /> },
    { label: "Liên Hệ", to: "/contact", icon: <PhoneOutlined /> },
  ];

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  const sidebarContent = (
    <div className="px-2 py-4">
      <div className="px-4 pb-4 mb-2 border-b border-blue-100 flex items-center justify-between">
        <h3 className="text-lg font-bold text-[#1e90ff]">VuaLingo</h3>
        {/* Close button only on mobile */}
        <button
          onClick={onClose}
          className="md:hidden w-8 h-8 rounded-full hover:bg-gray-200 flex items-center justify-center text-gray-500"
        >
          <CloseOutlined />
        </button>
      </div>
      <nav>
        <ul className="space-y-1">
          {menu.map((m) => (
            <li key={m.to}>
              <Link
                to={m.to}
                onClick={onClose}
                className={`flex items-center justify-between px-4 py-3 rounded-lg transition-all ${
                  isActive(m.to)
                    ? "bg-blue-500 text-white shadow-md shadow-blue-500/25"
                    : "text-gray-700 hover:bg-white hover:shadow"
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className={`text-lg ${isActive(m.to) ? "text-white" : "text-gray-400"}`}>{m.icon}</span>
                  <span className="font-medium">{m.label}</span>
                </div>
                {m.badge && (
                  <span className={`text-xs px-2 py-0.5 rounded-full ${
                    isActive(m.to) ? "bg-white/20 text-white" : "bg-red-500 text-white"
                  }`}>{m.badge}</span>
                )}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden md:block w-64 bg-[#f0f7fb] min-h-screen sticky top-[56px] shadow-inner flex-shrink-0">
        {sidebarContent}
      </aside>

      {/* Mobile Overlay */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose}></div>
          {/* Drawer */}
          <aside className="absolute left-0 top-0 bottom-0 w-72 bg-[#f0f7fb] shadow-2xl overflow-y-auto animate-slideIn">
            {sidebarContent}
          </aside>
        </div>
      )}

      {/* Inline style for slide animation */}
      <style>{`
        @keyframes slideIn {
          from { transform: translateX(-100%); }
          to { transform: translateX(0); }
        }
        .animate-slideIn {
          animation: slideIn 0.25s ease-out;
        }
      `}</style>
    </>
  );
}
